import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'shared/styles/constants';

export const useAvailableCustomFieldsStyles = makeStyles(theme => ({
    customFieldsBox: {
        maxWidth: theme.spacing(34),
        minHeight: theme.spacing(50),
    },
    customField: {
        border: `${colors.lightGray} 1px dashed`,
        margin: theme.spacing(1.5),
        width: theme.spacing(30),
    },
    customFieldInner: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'grab',
    },
    customFieldIcon: {
        padding: theme.spacing(1),
        color: colors.darkGray,
    },
    customFieldText: {
        fontSize: '12px',
    },
    customFieldNameWrapper: {
        display: 'flex',
        alignItems: 'center',
    },
}));
